import type { ReactNode } from 'react';
import styled from 'styled-components';

import { Button } from '@/components/atoms/Button/Button';

export const StickyButtonWrapper = styled.div<{
  children: ReactNode;
  isVisible: boolean;
}>`
  position: fixed;
  left: 50%;
  bottom: 20px;
  width: calc(100% - 24px);
  max-width: 500px;
  background-color: #fff;
  border-radius: 999px;
  z-index: 1000;
  transition: transform 0.3s ease;

  ${({ isVisible }) =>
    isVisible
      ? 'transform: translateX(-50%) translateY(0);'
      : 'transform: translateX(-50%) translateY(150%);'}
`;

export const StickyButtonContent = styled.div<{
  children: ReactNode;
  onClick?: () => void;
}>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 2px 12px;
  cursor: pointer;
`;

export const StickyCtaButton = styled(Button)`
  font-size: 13px;

  @media ${({ theme }) => theme.media.tablet} {
    font-size: 16px;
  }
`;

export const StickyThumbnail = styled.div`
  position: relative;
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 8px;
`;

export const StickyTitle = styled.p`
  flex: 1;
  min-width: 0;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.3;
  color: #444;

  span {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  @media ${({ theme }) => theme.media.tablet} {
    font-size: 13px;
  }
`;
